import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    if (this.data.has('persist')) {
      return;
    }

    setTimeout(() => this.element.remove(), 5000);
  }

  remove() {
    this.element.remove();
  }
}
